import omit from 'lodash/omit';
import { DATA_URL } from './FarmContext';

const headers = idToken => ({
  'Content-Type': 'application/json; charset=utf-8',
  'Authorization': 'FirebaseToken ' + idToken
})

export const saveModel = (user, model, id, data) => {
    let method = 'POST';
    let url = `/db/${model}/`;
    if (id !== 'new') {
    	method = 'PUT';
    	url = `/db/${model}/${id}/`;
    }
    return user.getIdToken().then(idToken => {
      return fetch(DATA_URL + url, {
        method: method,
        body: JSON.stringify(data),
        headers: headers(idToken),
      })
      .then(f => f.json())
    }).catch(function(error) {
      // Handle error
    });
}

export const saveAttachment = (user, model, data) => {
    let method = 'POST';
    let url = `/db/${model}/`;
    return user.getIdToken().then(idToken => {
      return fetch(DATA_URL + url, {
        method: method,
        body: data,
        headers: omit(headers(idToken), ['Content-Type']),
      })
      .then(f => f.json())
    }).catch(function(error) {
      // Handle error
    });
}

export const deleteAttachment = (user, model, id) => {
  return deleteModel(user, model, id);
}


export const saveComp = (user, compId, formData, boundary) => {
    const model = 'comps';
    const boundary_set = boundary.features;
    const data = {...formData, boundary_set};
    const id = compId;
    return saveModel(user, model, id, data);
}



const getModel = (user, id, model) => {
    return user.getIdToken().then(idToken => {
      return fetch(DATA_URL + `/db/${model}/${id}/`, {
        method: 'GET',
        headers: headers(idToken),
      })
      .then(f => f.json())
    }).catch(function(error) {
      // Handle error
    });
}

export const getComp = (user, compId) => getModel(user, compId, 'comps');


const deleteModel = (user, model, id) => {
    return user.getIdToken().then(idToken => {
      return fetch(DATA_URL + `/db/${model}/${id}/`, {
        method: 'DELETE',
        headers: headers(idToken),
      })
      .then(f => f.json())
    }).catch(function(error) {
      // Handle error
    });
}

export const deleteComp = (user, compId) => deleteModel(user, 'comps', compId);


export const getAllComps = (user) => {
    return user.getIdToken().then(idToken => {
      return fetch(DATA_URL + `/db/comps/`, {
        method: 'GET',
        headers: headers(idToken),
      })
      .then(f => f.json())
    }).catch(function(error) {
      // Handle error
    });
}



export const saveFkd = (user, fkdId, formData, boundary) => {
    const model = 'knowledge';
    const boundary_set = boundary.features;
    const data = {...formData, boundary_set};
    const id = fkdId;
    return saveModel(user, model, id, data);
}


export const getFkd = (user, fkdId) => getModel(user, fkdId, 'knowledge');


export const getAllFkd = (user) => {
    return user.getIdToken().then(idToken => {
      return fetch(DATA_URL + `/db/knowledge/`, {
        method: 'GET',
        headers: headers(idToken),
      })
      .then(f => f.json())
    }).catch(function(error) {
      // Handle error
    });
}


export const getAllFkdOldFilterd = (user, boundary) => {
    return user.getIdToken().then(idToken => {
      return fetch(DATA_URL + `/db/all-knowledge/`, {
        method: 'POST',
        body: JSON.stringify(boundary),
        headers: headers(idToken),
      })
      .then(f => f.json())
    }).catch(function(error) {
      // Handle error
    });
}

export const deleteFkd = (user, fkdId) => deleteModel(user, 'knowledge', fkdId);


export const getScrapedComps = async (user) => {
    return user.getIdToken().then(async idToken => {
      const url =  await fetch(DATA_URL + `/db/private-static/?key=data/scraped.json&bucket=acretrader-ds.appspot.com`, {
        method: 'GET',
        headers: headers(idToken),
      })
      .then(f => f.json())
      .then(f => f.url);

      return fetch(url)
        .then(f => f.json());

    }).catch(function(error) {
      // Handle error
    });
}